// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ESuranceMembershipSchema from './e-surance-membership-schema';
import ESuranceMembershipContactSchema from './e-surance-membership-contact-schema';
import ESuranceMembershipBusinessSchema from './e-surance-membership-business-schema';
import ESuranceInvoiceAddressSchema from './e-surance-invoice-address-schema';

const schema = {
  $id: '/create-e-surance-membership-request-schema',
  type: 'object',
  required: ['membership', 'membershipContact', 'membershipBusiness', 'invoiceAddress'],
  properties: {
    membership: {
      ...ESuranceMembershipSchema,
    },
    membershipContact: {
      ...ESuranceMembershipContactSchema,
    },
    membershipBusiness: {
      ...ESuranceMembershipBusinessSchema,
    },
    invoiceAddress: {
      ...ESuranceInvoiceAddressSchema,
    },
  },
} as IJSONSchema;

export default schema;
